import store from '@/store'
import { http } from '@/plugins/axios'
import { Notify } from 'vant'
import { testTel, isEmpty } from '@/tool/regular'

// 接口环境
const env = 'development'

// 配置接口环境对应域名 production为线上地址(必须) development为测试地址
const apisURL = {
    production: 'https://api.up-petroleum.com/api/v1/',
    development: 'https://apitest.up-petroleum.com/api/v1/',
}

// 生成接口baseUrl 生产环境强制为production
const baseURL = process.env.NODE_ENV == "production" ? apisURL['production'] : apisURL[env]

/**
 * 投票活动详情
 * @param {number} id 活动id
 */
function activityInfo({ id }) {
    if (!store.state.token) {
        Notify({ type: 'danger', message: '无登录凭证' });
    }

    return new Promise((resolve, reject) => {
        if (!id) {
            Notify({ type: 'warning', message: '数据异常，请重新加载页面' })
            return
        }

        http({ method: 'get', url: 'activityInfo', data: { id }, myBaseUrl: baseURL }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    });
}

/**
 * 报名投票活动
 * @param {number} activity_id 活动id
 * @param {string} title 报名名称
 * @param {string} people 姓名
 * @param {number} tel 联系电话
 */
function joinActivity({ activity_id, title, people, tel }) {
    if (!store.state.token) {
        Notify({ type: 'danger', message: '无登录凭证' });
    }

    return new Promise((resolve, reject) => {
        if (!activity_id) {
            Notify({ type: 'warning', message: '数据异常，请重新加载页面' })
            return
        }
        if (isEmpty(people)) {
            Notify({ type: 'warning', message: '未输入姓名' })
            return
        }
        if (!testTel(tel)) {
            Notify({ type: 'warning', message: '电话号码格式不正确' })
            return
        }
        if (isEmpty(title)) {
            Notify({ type: 'warning', message: '未输入报名名称' })
            return
        }

        http({ method: 'post', url: 'joinActivity', data: { activity_id, title, people, tel }, myBaseUrl: baseURL }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    });
}

/**
 * 投票
 * @param {number} activity_id 活动id
 * @param {number} item_id 选项id
 */
function vote({ activity_id, item_id }) {
    if (!store.state.token) {
        Notify({ type: 'danger', message: '无登录凭证' });
    }

    return new Promise((resolve, reject) => {
        if (!activity_id) {
            Notify({ type: 'warning', message: '数据异常，请重新加载页面' })
            return
        }
        if (!item_id) {
            Notify({ type: 'warning', message: '未选择电子会员卡名' })
            return
        }

        http({ method: 'post', url: 'vote', data: { activity_id, item_id }, myBaseUrl: baseURL }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    });
}


export {
    activityInfo,
    joinActivity,
    vote,
}
